import { render, staticRenderFns } from "./GroupedProducts.vue?vue&type=template&id=4a481286&"
import script from "./GroupedProducts.vue?vue&type=script&lang=js&"
export * from "./GroupedProducts.vue?vue&type=script&lang=js&"
import style0 from "./GroupedProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports